<template>
	<div class="service">
		<div class="service-tit">服务中心</div>
		<div class="service-content">
			<div class="service-tab">
				<p>服务分类</p>
				<p>系统功能</p>
				<p>剩余次数</p>
				<p>操作</p>
			</div>
			<article class="service-list" v-for="(item, index) in list" :key="index">
				<p class="service-ctit">{{ item.Title }}</p>
				<ul class="service-ul">
					<li v-for="(i, index) in item.Children" :key="index">
						<p>{{ i.Title }}</p>
						<p v-if="i.Title=='课程VIP卡'">-</p>
						<p v-if="i.Title=='课程VIP卡'">-</p>
						<p v-if="i.Title!='课程VIP卡'">{{ i.num >= 0 ? i.num + '次' : '无限次' }}</p>
						<p v-if="i.Title!='课程VIP卡'"><button class="service-btn" @click="useBtn(i.path, i.Key, i.num, i.id,i.type)">立即使用</button></p>
					</li>
				</ul>
			</article>
			<!-- <article class="service-list" v-for="(item, index) in list" :key="index">
				<p class="service-ctit">{{ item.tit }}</p>
				<ul class="service-ul">
					<li v-for="(i, index) in item.conList" :key="index">
						<p>{{ i.txt }}</p>
						<p>{{ i.num >= 0 ? i.num + '次' : '无限次' }}</p>
						<p><button class="service-btn" @click="useBtn(i.path, i.key, i.num, i.id)">立即使用</button></p>
					</li>
				</ul>
			</article> -->
		</div>
	</div>
</template>

<script>
	import {
		evaluation
	} from '../../assets/data/evaluation';
	import {
		mapState
	} from 'vuex';

	const infinityArr = ['Guide', 'Provincial', 'Paragraph', 'University', 'UniversityRank', 'ProfessionalInquiry',
		'OccupationInquiry'
	];
	const KeyList = [{
			name: '新高考选科测评',
			parent: '新高考选科测评',
			englishName: 'NewEvaluation',
			path: '/gaokao',
			id: 1
		}, {
			name: '根据科目选专业',
			parent: '新高考选科测评',
			englishName: 'Major',
			path: '/major',
			id: 0
		}, {
			name: '根据专业选科目',
			parent: '新高考选科测评',
			englishName: 'Subject',
			path: '/subject',
			id: 0
		}, {
			name: '升学规划测评',
			parent: '升学规划测评',
			englishName: 'Entrance',
			path: '/way',
			id: 2
		}, {
			name: '升学途径指南',
			parent: '升学规划测评',
			englishName: 'Guide',
			path: '/guide',
			id: 0
		}, {
			name: '学习风格测评',
			parent: '学业规划测评',
			englishName: 'Style',
			path: '/style',
			id: 3
		},
		{
			name: '学习时间管理测评',
			parent: '学业规划测评',
			englishName: 'LearningTime',
			path: '/style',
			id: 4
		}, {
			name: '学习心理调节测评',
			parent: '学业规划测评',
			englishName: 'Psychological',
			path: '/style',
			id: 5
		}, {
			name: '学业情绪管理测评',
			parent: '学业规划测评',
			englishName: 'EmotionManage',
			id: 6,
			path: '/style'
		}, {
			name: '学习态度、方法和能力综合测评',
			parent: '学业规划测评',
			englishName: 'Comprehensive',
			id: 7,
			path: '/style'
		}, {
			name: '学习习惯测评',
			parent: '学业规划测评',
			englishName: 'Habit',
			id: 8,
			path: '/style'
		}, {
			name: '学习动机诊断测评',
			parent: '学业规划测评',
			englishName: 'Motivation',
			id: 9,
			path: '/style'
		}, {
			name: 'Sarason考试焦虑测评',
			parent: '学业规划测评',
			englishName: 'StudySarason',
			id: 10,
			path: '/style'
		}, {
			name: '师生和同学关系测评',
			parent: '学业规划测评',
			englishName: 'Relationship',
			path: '/style',
			id: 11
		}, {
			name: '专业定位测评',
			parent: '职业规划测评',
			englishName: 'Orientation',
			path: '/style',
			id: 13
		}, {
			name: '施恩职业锚测评',
			parent: '职业规划测评',
			englishName: 'ShiEn',
			id: 14,
			path: '/style'
		}, {
			name: '气质测评',
			parent: '职业规划测评',
			englishName: 'Temperament',
			id: 15,
			path: '/style'
		}, {
			name: '舒伯职业价值观测评',
			parent: '职业规划测评',
			englishName: 'Shubo',
			id: 16,
			path: '/style'
		}, {
			name: '心理适应性测评',
			parent: '职业规划测评',
			englishName: 'Usability',
			id: 17,
			path: '/style'
		}, {
			name: '自信心测评',
			parent: '职业规划测评',
			englishName: 'Confidence',
			id: 18,
			path: '/style'
		}, {
			name: 'EQ情商测评',
			parent: '职业规划测评',
			englishName: 'EQ',
			id: 19,
			path: '/style'
		}, {
			name: 'DISC个性测评',
			parent: '职业规划测评',
			englishName: 'DISC',
			id: 20,
			path: '/style'
		}, {
			name: 'PDP性格测评',
			parent: '职业规划测评',
			englishName: 'ProfessionalPDP',
			id: 21,
			path: '/style'
		}, {
			name: '学生学情档案',
			parent: '学生学情档案',
			englishName: 'ArchivesPDP',
			path: '/fileindex',
			id: 0
		}, {
			name: '家长情况测评',
			parent: '家长情况测评',
			englishName: 'ParentPDP',
			path: '/style',
			id: 12
		}, {
			name: '查：高校分数线',
			parent: '高效查',
			englishName: 'UniversityScore',
			path: '/lastIndex',
			id: 0
		}, {
			name: '查：专业分数线',
			parent: '高效查',
			englishName: 'MajorScore',
			path: '/majorScore',
			id: 0
		}, {
			name: '查：省控分数线',
			parent: '高效查',
			englishName: 'Provincial',
			path: '/skScore',
			id: 0
		}, {
			name: '查：一分一段表',
			parent: '高效查',
			englishName: 'Paragraph',
			path: '/scoreTable',
			id: 0
		}, {
			name: '查：高校查询',
			parent: '高效查',
			englishName: 'University',
			path: '/lastSchool',
			id: 0
		}, {
			name: '查：大学排名',
			parent: '高效查',
			englishName: 'UniversityRank',
			path: '/lastRanking',
			id: 0
		}, {
			name: '查：专业查询',
			parent: '高效查',
			englishName: 'ProfessionalInquiry',
			path: '/lastMajor',
			id: 0
		}, {
			name: '查：职业查询',
			parent: '高效查',
			englishName: 'OccupationInquiry',
			path: '/occupation',
			id: 0
		}, {
			name: '查：招生章程',
			parent: '高效查',
			englishName: 'Admission',
			path: '/constitution',
			id: 0
		}, {
			name: '填：智能选院校',
			parent: '精准填',
			englishName: 'Colleges',
			path: '/znYuan',
			id: 0
		}, {
			name: '填：智能选专业',
			parent: '精准填',
			englishName: 'MajorSelect',
			path: '/znZhuan',
			id: 0
		}, {
			name: '填：录取风险评估',
			parent: '精准填',
			englishName: 'AdmissionRisk',
			path: '/assessment',
			id: 0
		}, {
			name: '填：同分数考生去向',
			parent: '精准填',
			englishName: 'Whereabout',
			path: '/lastGo',
			id: 0
		}, {
			name: '填：一键志愿填报',
			parent: '精准填',
			englishName: 'Voluntary',
			path: '/xzTianBaoIndex',
			type:1,
			id: 0
		}, {
			name: '填：高职专科填报',
			parent: '精准填',
			englishName: 'Voluntary2',
			path: '/xzTianBaoIndex',
			type:2,
			id: 0
		}, {
			name: '家庭学习与支持',
			parent: '家庭教育测评',
			englishName: 'FamilyStudy',
			id: 23,
			path: '/jthomeJiaTing'
		}, {
			name: '亲子关系',
			parent: '家庭教育测评',
			englishName: 'ParentChildRelationship',
			id: 24,
			path: '/jthomeQinZi'
		}, {
			name: '家庭环境',
			parent: '家庭教育测评',
			englishName: 'FamilyEnvironment',
			id: 25,
			path: '/jthomeHuanJing'
		}, {
			name: '家庭功能',
			parent: '家庭教育测评',
			englishName: 'FamilyFunction',
			id: 26,
			path: '/jthomeGongNeng'
		},
		{
			name: '青少年上网成瘾自评',
			parent: '家庭教育测评',
			englishName: 'TeenagerAddicted',
			id: 27,
			path: '/jthomeeZiPing'
		},
		// {
		// 	name: '考研常识',
		// 	parent: '考研',
		// 	englishName: 'NewEvaluationCard',
		// 	id: 1,
		// 	path: '/kyStudyGaoKao'
		// },
		// {
		// 	name: '报考指南',
		// 	parent: '考研',
		// 	englishName: 'EntranceCard',
		// 	id: 2,
		// 	path: '/kyStudyShengXue'
		// },
		// {
		// 	name: '复试指南',
		// 	parent: '考研',
		// 	englishName: 'StudyCard',
		// 	id: 3,
		// 	path: '/kyStudyGuiHua'
		// },
		// {
		// 	name: '院校专业',
		// 	parent: '考研',
		// 	englishName: 'ProfessionCard',
		// 	id: 4,
		// 	path: '/kyStudyZhiYe'
		// },
		// {
		// 	name: '分数线',
		// 	parent: '考研',
		// 	englishName: 'ExamCard',
		// 	id: 5,
		// 	path: '/kyStudyKaoYan'
		// },
		{
			name: '课程VIP',
			parent: '课程VIP卡',
			englishName: 'TeenagerAddicted',
			id: 0,
			path: '/myClassVip'
		}
	];

	const list = [{
			tit: '新高考选科测评',
			conList: [{
					txt: '新高考选科测评',
					num: 0,
					path: '/gaokao',
					id: 1
				},
				{
					txt: '根据科目选专业',
					num: 0,
					path: '/major'
				},
				{
					txt: '根据专业选科目',
					num: 0,
					path: '/subject'
				}
			]
		},
		{
			tit: '升学规划测评',
			conList: [{
					txt: '升学途径指南',
					num: 0,
					path: '/guide'
				},
				{
					txt: '升学途径分析测评',
					num: 0,
					path: '/way',
					id: 2
				}
			]
		},
		{
			tit: '学业规划测评',
			conList: [{
					txt: '学习风格测评',
					num: 0,
					path: '/style',
					id: 3
				},
				{
					txt: '学业时间管理测评',
					num: 0,
					path: '/style',
					id: 4
				},
				{
					txt: '学业心理调节测评',
					num: 0,
					path: '/style',
					id: 5
				},
				{
					txt: '学业情绪管理测评',
					num: '1次',
					id: 6,
					path: '/style'
				},
				{
					txt: '学习态度、方法和能力综合测评',
					num: '1次',
					id: 7,
					path: '/style'
				},
				{
					txt: '学习习惯测评',
					num: '1次',
					id: 8,
					path: '/style'
				},
				{
					txt: '学习动机诊断测评',
					num: '1次',
					id: 9,
					path: '/style'
				},
				{
					txt: 'Sarason考试焦虑测评',
					num: '1次',
					id: 10,
					path: '/style'
				},
				{
					txt: '师生和同学关系测评',
					num: 0,
					path: '/style',
					id: 11
				}
			]
		},
		{
			tit: '职业规划测评',
			conList: [{
					txt: '专业定位测评',
					num: 0,
					path: '/style',
					id: 13
				},
				{
					txt: '施恩职业锚测评',
					num: '不限次',
					id: 14,
					path: '/style'
				},
				{
					txt: '气质测评',
					num: '1次',
					id: 15,
					path: '/style'
				},
				{
					txt: '舒伯职业价值观测评',
					num: '1次',
					id: 16,
					path: '/style'
				},
				{
					txt: '心理适应性测评',
					num: '1次',
					id: 17,
					path: '/style'
				},
				{
					txt: '自信心测评',
					num: '1次',
					id: 18,
					path: '/style'
				},
				{
					txt: 'EQ情商测评',
					num: '1次',
					id: 19,
					path: '/style'
				},
				{
					txt: 'DISC个性测评',
					num: '1次',
					id: 20,
					path: '/style'
				},
				{
					txt: 'PDP性格测评',
					num: '1次',
					id: 21,
					path: '/style'
				}
			]
		},
		{
			tit: '学生学情档案',
			conList: [{
				txt: '学生学情档案',
				num: 0,
				path: '/fileindex'
			}]
		},
		{
			tit: '家长情况测评',
			conList: [{
				txt: '家长情况测评',
				num: 0,
				path: '/style',
				id: 12
			}]
		},
		{
			tit: '高效查',
			conList: [{
					txt: '查:高校分数线',
					num: 0,
					path: '/lastIndex'
				},
				{
					txt: '查:专业分数线',
					num: 0,
					path: '/majorScore'
				},
				{
					txt: '查:省控分数线',
					num: 0,
					path: '/skScore'
				},
				{
					txt: '查:一分一段表',
					num: 0,
					path: '/scoreTable'
				},
				{
					txt: '查:高校查询',
					num: 0,
					path: '/lastSchool'
				},
				{
					txt: '查:大学排名',
					num: 0,
					path: '/lastRanking'
				},
				{
					txt: '查:专业查询',
					num: 0,
					path: '/lastMajor'
				},
				{
					txt: '查:职业查询',
					num: 0,
					path: '/occupation'
				},
				{
					txt: '查:招生章程',
					num: 0,
					path: '/constitution'
				}
			]
		},
		{
			tit: '精准填',
			conList: [{
					txt: '填:智能选院校',
					num: 0,
					path: '/znYuan'
					// path: '/lastYuan'
				},
				{
					txt: '填:智能选专业',
					num: 0,
					path: '/znZhuan'
					// path: '/lastZy'
				},
				{
					txt: '填:录取风险评估',
					num: 0,
					path: '/assessment'
				},
				{
					txt: '填:同分数考生去向',
					num: 0,
					path: '/lastGo'
				},
				{
					txt: '填:一键志愿填报',
					num: 0,
					path: '/xzTianBaoIndex'
				},
				{
					txt: '填：高职专科填报',
					num: 0,
					path: '/xzTianBaoIndex'
				}
			]
		},
		{
			tit: '家庭教育测评',
			conList: [{
					txt: '家庭学习与支持测评',
					num: 0,
					id: 23,
					path: '/myhomeJiaTing'
				},
				{
					txt: '亲子关系测评',
					num: 0,
					id: 24,
					path: '/myhomeQinZi'
				},
				{
					txt: '家庭环境测评',
					num: 0,
					id: 25,
					path: '/myhomeHuanJing'
				},
				{
					txt: '家庭功能测评',
					num: 0,
					id: 26,
					path: '/myhomeGongNeng'
				},
				{
					txt: '青少年上瘾自评测评',
					num: 0,
					id: 27,
					path: '/myhomeeZiPing'
				}
			]
		}
		// {
		// 	tit: '考研',
		// 	conList: [{
		// 			txt: '新高考选科测评卡',
		// 			num: 1,
		// 			path: '/myStudyGaoKao'
		// 		},
		// 		{
		// 			txt: '升学规划测评卡',
		// 			num: 2,
		// 			path: '/myStudyShengXue'
		// 		},
		// 		{
		// 			txt: '学业规划测评卡',
		// 			num: 3,
		// 			path: '/myStudyGuiHua'
		// 		},
		// 		{
		// 			txt: '职业规划测评卡',
		// 			num: 4,
		// 			path: '/myStudyZhiYe'
		// 		},
		// 		{
		// 			txt: '考研',
		// 			num: 5,
		// 			path: '/myStudyKaoYan'
		// 		}
		// 	]
		// },
		// {
		// 	tit: '课程',
		// 	conList: [{
		// 		txt: '课程VIP',
		// 		num: 0,
		// 		path: '/myClassVip'
		// 	}]
		// }
	];

	export default {
		name: 'service',
		data() {
			return {
				list: [],
				outUrl: ''
			};
		},
		created() {
			this.GetCardCategory();
			this.getOutUrl();
		},
		computed: {
			...mapState(['user'])
		},
		methods: {
			// 获取卡分类
			getCardCategory1() {
				this.$api.getEnabledCardCategory().then(res => {
					console.log('数据', res.data);
					const nameArr = res.data.filter(a => a).map(a => a.substring(0, a.length - 4));
					console.log('nameArrdd', nameArr);
					this.list = list.filter(a => {
						const dd = nameArr.some(b => {
							if ((b.includes('学情管理') && a.tit.includes('学生学情')) || (b.includes(
									'家长测评') && a.tit.includes('家长情况'))) {
								return true;
							} else {
								return a.tit.includes(b);
							}
						});
						return dd;
					});
					console.log('this.list', this.list);
					this.getUserEvaluationInfo();
				});
			},
			// 获取用户测评次数信息
			getUserEvaluationInfo() {
				this.$api.getUserEvaluation().then(res => {
					console.log('res.data', res.data);
					for (const key in res.data) {
						if (res.data.hasOwnProperty(key)) {
							const element = res.data[key];
							if (key.includes('Num') && typeof element === 'number') {
								const mapDataKey = key.substring(0, key.length - 3);
								const mapData = evaluation[mapDataKey];
								if (mapData) {
									const parentCategory = this.list.find(a => a.Name === mapData.parent);
									// const parentCategoryIndex = this.list.findIndex(a => a.tit === mapData.parent);
									// const parentCategory = this.list[parentCategoryIndex];
									if (parentCategory) {
										const item = parentCategory.conList.find(a => a.Name === mapData.name);
										// const itemIndex = parentCategory.conList.findIndex(a => a.txt === mapData.name);
										// const item = parentCategory.conList[itemIndex];
										if (item) {
											const isInfinity = res.data[`Is${mapDataKey}`];
											item.num = infinityArr.includes(mapDataKey) ? -1 : isInfinity ? -1 : element;
											item.key = mapDataKey;
											// this.$set(this.list[parentCategoryIndex].conList[itemIndex], itemIndex, item);
										}
									}
								}
							}
						}
					}
					// console.log('111111111111111', this.list);
					// this.list[6].conList[0].num = 99;
					// this.list[6].conList[1].num = 99;
					// this.list[7].conList[0].num = 99;
					// this.list[7].conList[1].num = 99;
					// this.list[8].conList[0].num = 99;
					// this.list[8].conList[1].num = 99;
					// this.list[8].conList[2].num = 99;
					// this.list[8].conList[3].num = 99;
					// this.list[8].conList[4].num = 99;
				});
			},
			// 获取卡片
			GetCardCategory: function() {
				var that = this;
				var isTeacherLogin=sessionStorage.getItem('IsTeacherLogin');
				isTeacherLogin=isTeacherLogin?2:0;
				that.$api.HtppRequest(
					'WebsiteSet/CardCategory?isIndex='+isTeacherLogin,
					'GET', {},
					function(res) {
						console.log('获取卡片');
						console.log(res);
						if (res.code === 0) {
							var list = res.data;
							list.forEach(a => {
								if(a.Title=='智能填报'){
									a.Title='高效查'
								}
								a.Children.forEach(c => {
									KeyList.map(b => {
										if (c.Title === b.name) {
											c.Key = b.englishName;
											c.num = 0;
											c.id = b.id;
											c.path = b.path;
											c.type = b.type?b.type:0
										}
									});
								});
							});
							that.list = list;
							that.getUserEvaluationInfoNew();
							console.log('处理后的卡牌', that.cardList);
						}
					},
					function(res) {}
				);
			},
			// 获取用户测评次数信息
			getUserEvaluationInfoNew() {
				this.$api.getUserEvaluation().then(res => {
					var newList = this.list;
					
					for (const key in res.data) {
						if (res.data.hasOwnProperty(key)) {
							const element = res.data[key];
							if (key.includes('Num') && typeof element === 'number') {
								const mapDataKey = key.substring(0, key.length - 3);
								const isInfinity = res.data[`Is${mapDataKey}`];
								// var num = infinityArr.includes(mapDataKey) ? -1 : isInfinity ? -1 : element;
								var num = isInfinity ? -1 : element;
								newList.forEach(b => {
									b.Children.forEach(c => {
										if (c.Key === mapDataKey) {
											c.num = num;
										}
									});
								});
							}
						}
					}
					this.list = newList;
					console.log('组合后的数组', newList);
				});
			},
			getOutUrl() {
				this.$api.getOutUrl().then(res => {
					let url = res.url;
					if (res.url && !res.url.includes('http')) {
						url = `http://${res.url}`;
					}
					this.outUrl = url;
				});
			},
			useBtn(e, key, num, id,type) {
				console.log(e, key, num, id,type);
				if (!this.user.user || !this.user.user.CityCode) {
				    this.$confirm('您还未完善信息,请先完善！', '提示', {
				        confirmButtonText: '确定',
				        cancelButtonText: '取消',
				        type: 'warning'
				    }).then(() => {
				        this.$router.push('/datum');
				    }).catch(() => {
				    });
					return;
				}
				if (e === '/myClassVip') {
					return;
				}
				if (num === 0) {
					this.$util.showError('次数不足');
					return;
				}
				if (e === '/constitution') {
					this.$api.reduceUserCount({
						key: key
					});
					window.open(this.outUrl);
				} else {
					this.$router.push({
						path: e,
						query: {
							key,
							id,
							type
						}
					});
				}
			}
		}
	};
</script>

<style scoped>
	.service {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.service-tit {
		padding: 20px;
		height: auto;
		border-bottom: 1px solid #eee;
		font-size: 16px;
		color: #333;
		position: relative;
	}

	.service-tit::after {
		position: absolute;
		content: '';
		width: 70px;
		height: 2px;
		background-color: #333;
		bottom: 0;
		left: 0;
		margin-left: 17px;
	}

	/* service-content */
	.service-content {
		margin: 25px auto;
		width: calc(100% - 40px);
		height: auto;
		overflow: hidden;
		border: 1px solid #ccc;
	}

	.service-tab {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		background: rgba(0, 0, 0, 0.6);
	}

	.service-tab p {
		width: 23%;
		text-align: center;
		height: 60px;
		line-height: 60px;
		font-size: 15px;
		color: #fff;
	}

	.service-tab p:nth-child(2) {
		width: 31%;
	}

	/* service-list */
	.service-list {
		width: 100%;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
	}

	.service-list:last-child {
		border-bottom: none;
	}

	.service-ctit {
		width: 23%;
		height: auto;
		overflow: hidden;
		text-align: center;
		font-size: 15px;
		color: #333;
	}

	.service-ul {
		border-left: 1px solid #ccc;
		width: 77%;
		height: auto;
		overflow: hidden;
	}

	.service-ul li {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
	}

	.service-ul li:last-child {
		border-bottom: none;
	}

	.service-ul li p {
		width: 30%;
		height: auto;
		overflow: hidden;
		font-size: 15px;
		color: #333;
		border-right: 1px solid #ccc;
		text-align: center;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.service-ul li p:first-child {
		width: 40%;
	}

	.service-ul li p:last-child {
		border-right: none;
	}

	.service-btn {
		width: 80px;
		height: 30px;
		line-height: 28px;
		text-align: center;
		font-size: 14px;
		color: #333;
		border: 1px solid #333;
		border-radius: 6px;
		/* margin: 0 auto; */
		cursor: pointer;
	}
</style>
